module.exports = __webpack_public_path__ + "img/carefulNo.00a41b35.svg";